import { Box, styled } from "@mui/material";
import theme from "assets/styles/themes";
import { shouldForwardProp } from "utils";

const EntityWrapperColors = {
    primary: theme.palette.common.white,
    selected: theme.palette.background.green,
};

// Type
type EntityWrapperProps = {
    size?: "small" | "medium" | "big";
    backgroundColor?: keyof typeof EntityWrapperColors;
};

const EntityWrapper = styled(Box, {
    shouldForwardProp: (prop) => shouldForwardProp<EntityWrapperProps>(["size", "backgroundColor"], prop),
})<EntityWrapperProps>(({ size, backgroundColor, theme }) => ({
    backgroundColor: EntityWrapperColors[backgroundColor ?? "primary"],
    width: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    borderRadius: 4,
    marginBottom: theme.spacing(0.5),
    padding: theme.spacing(1, 2),
}));

export default EntityWrapper;
